import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { Dashboard } from '@/api/reports';

export function useDashboard() {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: () => api.get<Dashboard>('/api/dashboard'),
    // The server itself caches this for 10s; polling a little slower than
    // that keeps the till fresh without doubling up on server-side work.
    refetchInterval: 15_000,
  });
}
